import { IHttpService, IPromise, noop } from "angular";
import { EnvironmentService } from "@gtmhub/env";
import { IUser } from "../users/models";
import { IUserAccountRequest } from "./models";

export class LoginService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public ensureUserAccount(userAccountModel: IUserAccountRequest): IPromise<IUser> {
    const url = this.env.getApiEndpoint("/users/account");

    return this.$http.post<IUser>(url, userAccountModel).then((response) => response.data);
  }

  public checkAccountDomain(account: Partial<{ accountName: string; domain: string }>): IPromise<void> {
    const url = this.env.getApiEndpoint("/accounts/domain");

    return this.$http.post(url, account).then(noop);
  }
}
